// اضافه کردن کتابخانه ها به صفحه
import * as React from 'react'
import ParsiMap from "./parsiMap";
import Neshan from "./neshan";
import {useSnackbar} from "notistack";


var neshanToken = {
  headers: {
    'Api-Key': 'service.8c667d9069564606b33ad1074e71dc40'
  },
};

function SimpleMap(props) {
  const {enqueueSnackbar} = useSnackbar();

  const mapRef = React.useRef(null)

  // متغیر و useState های لوکال صفحه
  const [lng, setLng] = React.useState(51.4);
  const [lat, setLat] = React.useState(35.7);
  const zoom = 10
  const [mapObject, setMapObject] = React.useState()
  const [parsiMap, setParsiMap] = React.useState(false)


  React.useEffect(() => {
    let state = props?.searchInMap?.split('-')[0]
    let city = props?.searchInMap?.split('-')[1]
    state && handlerSearchWithAddress('استان' + ' ' + state + ' شهر' + ' ' + city)
  }, [props?.searchInMap]);

  React.useEffect(() => {
    fetch(`https://api.parsimap.ir/styles/parsimap-streets-v11?key=p1a17b4952e44846b5a486861f1f7c9153c49fdb24`).then((response) => response).then((data) => {
      setParsiMap(data.ok)
    }).catch((e) => console.log('error', e))
  }, [])


  React.useEffect(() => {
    mapRef.current?.flyTo({center: [props?.lngToMap, props?.latToMap]})
  }, [props?.latToMap])


  const handleError = (error) => {
    console.error('An error occurred:', error);
  };

  const setLngLat = (e) => {
    props.handlerLngFromMap(e?.lngLat?.lng)
    props.handlerLatFromMap(e?.lngLat?.lat)
  }


  const handlerSearchWithLocation = async (lng, lat) => {
    try {
      return await Promise.race([
        handlerSearchWithLocationInParsiMap(lng, lat),
        handlerSearchWithLocationInNeshan(lng, lat)
      ]);
    } catch (error) {
      console.error(error);
    }
  }

  const handlerSearchWithAddress = async (e) => {
    // try {
    //   return await Promise.race([
    handlerSearchWithAddressInParsiMap(e)
    //     handlerSearchWithAddressInNeshan(e)
    //   ]);
    // } catch (error) {
    //   console.error(error);
    // }
  }

  const handlerSearchWithAddressInParsiMap = (e) => {
    if (e?.length > 3) {
      fetch(`https://api.parsimap.ir/geocode/forward?key=p1c9f614aca0364596a8d3bfbdd24552b3cc465c5f&search_text=${e}&district=ST۲۳۰۱۰۲۱۵۷۶&only_in_district=true&subdivision=false&plate=false&request_id=false&search_precision=simple`).then((response) => response.json()).then((data) => {
        if (data?.status === "OK") {
          setLngLat({
            lngLat: {
              lng: data?.results[0]?.geo_location?.center?.lng,
              lat: data?.results[0]?.geo_location?.center?.lat
            }
          })
          mapObject?.flyTo([data?.results[0]?.geo_location?.center?.lat, data?.results[0]?.geo_location?.center?.lng], zoom)
        } else {
          handlerSearchWithAddressInNeshan(e)
        }

      }).catch((e) => console.log('handlerSearchWithAddressInParsiMap', e))
    }
  }

  const handlerSearchWithLocationInParsiMap = (lng, lat) => {
    fetch(`https://api.parsimap.ir/geocode/reverse?key=p1c9f614aca0364596a8d3bfbdd24552b3cc465c5f&location=${lng},${lat}&local_address=false&approx_address=false&subdivision=false&plate=false&request_id=false`).then((response) => response.json()).then((data) => props.handlerAddressFromMap(data)).catch((e) => console.log('handlerSearchWithLocationInParsiMap', e))
  }

  const handlerSearchWithAddressInNeshan = (e) => {
    fetch(`https://api.neshan.org/v4/geocoding?address=${e}`, neshanToken).then(data => {
      // console.log('data', data)
      if (data?.status === "NO_RESULT") {
        enqueueSnackbar('موردی یافت نشد', {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      } else {
        setLngLat({
          lat: data?.data?.location?.y,
          lng: data?.data?.location?.x
        });
        mapObject?.flyTo([data?.data?.location?.y, data?.data?.location?.x], zoom);
      }

    }).catch(e => console.log('handlerSearchWithAddressInNeshan', e));
  }

  const handlerSearchWithLocationInNeshan = (lng, lat) => {
    fetch(`https://api.neshan.org/v5/reverse?lat=${lat}&lng=${lng}`, neshanToken).then(data => {
      // props.handlerAddressFromMap(data)
      // console.log('data', data)

    }).catch(e => console.log('handlerSearchWithLocationInNeshan', e));
  }

  return (
     <>
       <div className="simple-map">

         {
           parsiMap ?
              <ParsiMap
                 mapRef={mapRef}
                 lngToMap={props.lngToMap || lng}
                 latToMap={props.latToMap || lat}
                 coordinates={props.coordinates}
                 zoom={props.zoom || zoom}
                 setLngLat={(event) => setLngLat(event)}
                 handlerSearchWithLocation={(event1, event2) => handlerSearchWithLocation(event1, event2)}
                 handleError={(event) => handleError(event)}
              />
              :
              <Neshan
                 lngToMap={props.lngToMap || lng}
                 latToMap={props.latToMap || lat}
                 coordinates={props.coordinates}
                 zoom={props.zoom || zoom}
                 mapObject={mapObject}
                 setLngLat={(event) => setLngLat(event)}
                 setMapObject={(event) => setMapObject(event)}
                 handlerSearchWithLocation={(event1, event2) => handlerSearchWithLocation(event1, event2)}
              />
         }


         {/*{*/}
         {/*  props?.showSearchInMap &&*/}
         {/*  <div className="map-search">*/}
         {/*    <Autocomplete*/}
         {/*       inputValue={addressText}*/}
         {/*       id="free-solo-demo"*/}
         {/*       noOptionsText={t("autoComplete.t1")}*/}
         {/*       freeSolo*/}
         {/*       autoHighlight*/}
         {/*       filterSelectedOptions*/}
         {/*       onChange={(e, value) => {*/}
         {/*         setLngLat({*/}
         {/*              lngLat: {*/}
         {/*                lng: value?.geo_location?.center?.lng,*/}
         {/*                lat: value?.geo_location?.center?.lat*/}
         {/*              }*/}
         {/*            }*/}
         {/*         )*/}
         {/*       }}*/}
         {/*       options={addressList}*/}
         {/*       getOptionLabel={(option) => option?.description}*/}
         {/*       renderInput={*/}
         {/*         (params) => <TextField*/}
         {/*            {...params}*/}
         {/*            hiddenLabel*/}
         {/*            size="small"*/}
         {/*            placeholder={t("map.t1")}*/}
         {/*            onChange={event => handlerSearchWithAddress(event?.target?.value)}/>*/}
         {/*       }*/}
         {/*    />*/}
         {/*  </div>*/}
         {/*}*/}
       </div>
     </>
  );
}


export default SimpleMap;
